const cookTime = `
    cook_time {
        data
        img_url
        img_title
    }
`;

const servingsNumber = `
    servings_number {
        data
        img_url
        img_title
    }
`;

const prepTime = `
    prep_time {
        data
        img_url
        img_title
    }
`;

const options = `
    options {
        code
        values {
            id
            label
            img_url
        }
    }
`;

const items = `
    recipe_id
    title
    url_key
    short_description
    thumbnail {
        url
        alt
    }
`;


const recipes = `
    query recipes($search: String, $filter: RecipeFilterInput, $pageSize: Int, $currentPage: Int) {
        recipes(search: $search, filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
            items {
                ${items}
                ${cookTime}
                ${servingsNumber}
                ${prepTime}
                ${options}
            }
            total_count
            page_info {
                current_page
            }    
        }
    }
`;

export default {
    recipes,
};
